<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 20px"></div>
    <div style="height: 50px;margin: 0 20px">
      <el-date-picker v-fixZoom
        v-model="callDate"
        type="daterange"
        unlink-panels
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        value-format="yyyyMMdd"
        style="margin-right: 10px; width: 400px">
      </el-date-picker>
      <el-input
        prefix-icon="el-icon-search"
        placeholder="输入号码搜索"
        v-model="searchKeyword"
        style="width: 350px"
      type="number"
      @blur="blurSearch">
      </el-input>
      <el-button type="primary" @click="queryCallInfo()">查询</el-button>
      <el-button icon="el-icon-download" type="success" @click="getAllCallHistoryByDate">导出当前所选日期呼叫记录</el-button>
    </div>
    <div style="max-height: calc(100% - 71px);margin: 0 20px;overflow-y: auto;">
      <div style="max-height: calc(100% - 60px);overflow-y: auto;">
        <el-table
          v-loading="loading"
          element-loading-text="加载中，请耐心等待。"
          :data="tableData"
          border
          style="width: 100%"
          highlight-current-row
          ref="singleTable">
          <el-table-column
            type="index"
            label="序号"
            width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="p_name"
            label="用户姓名"
            min-width="75"
            align="center">
          </el-table-column>
          <el-table-column
            prop="fromnum"
            label="主叫号码"
            min-width="100"
            align="center">
          </el-table-column>
          <el-table-column
            label="被叫号码"
            min-width="100"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.tonum}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="电话方向"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{getCallType(scope.row.calltype)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="通话标记"
            min-width="90"
            align="center">
            <template slot-scope="scope">
              <span>{{getCallTypeTag(scope.row.typetag)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="响铃时间"
            min-width="140"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.calltime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="接通时间"
            min-width="140"
            align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.begintime !== '0000-00-00 00:00:00'">{{scope.row.begintime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="结束时间"
            min-width="140"
            align="center">
            <template slot-scope="scope">
              <span>{{scope.row.endtime}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="响铃时长"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{getCallTime1(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="通话时长"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <span>{{getCallTime(scope.row)}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="是否接通"
            min-width="70"
            align="center">
            <template slot-scope="scope">
              <strong :style="{color: scope.row.begintime === '0000-00-00 00:00:00' ? 'red' : 'green'}">{{isCall(scope.row)}}</strong>
            </template>
          </el-table-column>
          <el-table-column
            prop="remark"
            label="通话小结"
            min-width="70"
            align="center">
          </el-table-column>
          <el-table-column
            prop="agentno"
            label="客服号码"
            min-width="75"
            align="center">
          </el-table-column>
          <el-table-column
            prop="sp_name"
            label="客服姓名"
            min-width="75"
            align="center">
          </el-table-column>
        </el-table>
      </div>
      <div style="margin-top: 10px;height: 40px;text-align: center">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCells">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import {querycalllist, searchcalllist} from '../../api/callInfo'

export default {
  name: 'callInfo',
  data () {
    return {
      downshow: false,
      downData: [],
      loading: false,
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      searchKeyword: '',
      tableData: [],
      callDate: [],
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        },
        shortcuts: []
      }
    }
  },
  created () {
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    const date = new Date().format('yyyyMMdd')
    this.callDate = [date, date]
    this.getTimeObj()
    this.getCallInfoTable()
  },
  methods: {
    // 时间
    mGetDate (year, month) {
      const d = new Date(year, month, 0)
      return d.getDate()
    },
    getTimeObj () {
      const dataArr = []
      const data = new Date()
      data.setMonth(data.getMonth() + 1, 1)// 获取到当前月份,设置月份
      for (let i = 0; i < 4; i++) {
        data.setMonth(data.getMonth() - 1) // 每次循环一次 月份值减1
        let m = data.getMonth() + 1
        m = m < 10 ? '0' + m : m
        dataArr.push(data.getFullYear() + '-' + (m))
      }
      const endDate = []
      for (let i = 1; i < dataArr.length; i++) {
        const arr = dataArr[i].split('-')
        const obj = {}
        let endDay = ''
        if (arr[1][0] === '0') {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1][1]))
          obj.text = arr[0] + '年' + arr[1][1] + '月'
        } else {
          endDay = this.mGetDate(parseInt(arr[0]), parseInt(arr[1]))
          obj.text = arr[0] + '年' + arr[1] + '月'
        }
        obj.start = arr[0] + arr[1] + '01'
        obj.end = arr[0] + arr[1] + endDay
        endDate.push(obj)
      }
      const arrTime = [
        {
          text: '本月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setDate(1)
            picker.$emit('pick', [start, end])
          }
        }
      ]
      for (let i = 0; i < endDate.length; i++) {
        const item = {
          text: endDate[i].text,
          onClick (picker) {
            picker.$emit('pick', [endDate[i].start, endDate[i].end])
          }
        }
        arrTime.push(item)
      }
      this.pickerOptions.shortcuts = arrTime
    },
    getCallInfoTable () {
      this.loading = true
      let data = {
        from: this.callDate[0] + '000000',
        to: this.callDate[1] + '235959'
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      querycalllist(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.calllist
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    searchCallInfo () {
      this.loading = true
      let data = {
        from: this.callDate[0] + '000000',
        to: this.callDate[1] + '235959',
        phone: this.searchKeyword
      }
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      searchcalllist(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.tableData = res.data.calllist
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    queryCallInfo () {
      if (this.searchKeyword === '') {
        this.getCallInfoTable()
      } else {
        this.searchCallInfo()
      }
    },
    blurSearch () {
      if (this.searchKeyword === '') {
        this.getCallInfoTable()
      }
    },
    getCallType (calltype) {
      let type = ''
      if (calltype === 'dialout') {
        type = '呼出'
      } else if (calltype === 'dialin') {
        type = '呼入'
      } else {
        type = calltype
      }
      return type
    },
    getCallTypeTag (typetag) {
      // 通话标记  说明  1 ringing =  响铃 2 answer  = 接通 4 end  = 结束 值为相加结果
      let tag = ''
      if (typetag === 1) {
        tag = '正在响铃'
      } else if (typetag === 3) {
        tag = '正在接听'
      } else if (typetag === 5) {
        tag = '未接听'
      } else if (typetag === 7) {
        tag = '完成通话'
      } else {
        tag = typetag
      }
      return tag
    },
    getCallTime1 (row) {
      let stime = Date.parse(new Date(row.calltime))
      let etime = ''
      if (row.begintime === '0000-00-00 00:00:00') {
        etime = Date.parse(new Date(row.endtime))
      } else {
        etime = Date.parse(new Date(row.begintime))
      }
      // const stime = Date.parse(new Date(row.begintime))
      // const etime = Date.parse(new Date(row.endtime))
      // 两个时间戳相差的毫秒数
      const usedTime = etime - stime
      // 计算相差的天数
      const days = Math.floor(usedTime / (24 * 3600 * 1000))
      // 计算天数后剩余的毫秒数
      const leave1 = usedTime % (24 * 3600 * 1000)
      // 计算出小时数
      const hours = Math.floor(leave1 / (3600 * 1000))
      // 计算小时数后剩余的毫秒数
      const leave2 = leave1 % (3600 * 1000)
      // 计算相差分钟数
      const minutes = Math.floor(leave2 / (60 * 1000))
      // 计算分钟数后剩余的毫秒数
      const leave3 = leave2 % (60 * 1000)
      // 计算相差秒数
      const second = Math.floor(leave3 / 1000)
      let time = ''
      if (days !== 0) {
        time = days + '天' + hours + '时' + minutes + '分' + second + '秒'
      } else if (hours !== 0) {
        time = hours + '时' + minutes + '分' + second + '秒'
      } else if (minutes !== 0) {
        time = minutes + '分' + second + '秒'
      } else {
        time = second + '秒'
      }
      return time
    },
    getCallTime (row) {
      if (row.endtime !== '0000-00-00 00:00:00' && row.endtime !== '' && row.begintime !== '0000-00-00 00:00:00' && row.begintime !== '') {
        const stime = Date.parse(new Date(row.begintime))
        const etime = Date.parse(new Date(row.endtime))
        // 两个时间戳相差的毫秒数
        const usedTime = etime - stime
        // 计算相差的天数
        const days = Math.floor(usedTime / (24 * 3600 * 1000))
        // 计算天数后剩余的毫秒数
        const leave1 = usedTime % (24 * 3600 * 1000)
        // 计算出小时数
        const hours = Math.floor(leave1 / (3600 * 1000))
        // 计算小时数后剩余的毫秒数
        const leave2 = leave1 % (3600 * 1000)
        // 计算相差分钟数
        const minutes = Math.floor(leave2 / (60 * 1000))
        // 计算分钟数后剩余的毫秒数
        const leave3 = leave2 % (60 * 1000)
        // 计算相差秒数
        const second = Math.floor(leave3 / 1000)
        let time = ''
        if (days !== 0) {
          time = days + '天' + hours + '时' + minutes + '分' + second + '秒'
        } else if (hours !== 0) {
          time = hours + '时' + minutes + '分' + second + '秒'
        } else if (minutes !== 0) {
          time = minutes + '分' + second + '秒'
        } else {
          time = second + '秒'
        }
        return time
        // const time = days + '天' + hours + '时' + minutes + '分' + second + '秒'
        // console.log(time)  // 1天0时3分17秒
      }
    },
    isCall (row) {
      if (row.begintime === '0000-00-00 00:00:00') {
        return '未接通'
      } else {
        return '已接通'
      }
    },
    handleSizeChange (val) {
      this.pageSize = val
      if (this.searchKeyword === '') {
        this.getCallInfoTable()
      } else {
        this.searchCallInfo()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.searchKeyword === '') {
        this.getCallInfoTable()
      } else {
        this.searchCallInfo()
      }
    },
    // 导出
    getAllCallHistoryByDate () {
      this.$message({
        type: 'info',
        message: '数据加载中，请耐心等待。',
        duration: 0
      })
      let params = {
        page: 1,
        size: 10
      }
      let data = {
        from: this.callDate[0] + '000000',
        to: this.callDate[1] + '235959'
      }
      querycalllist(params, data).then(res => {
        if (res.data.cnt === 0) {
          this.$message.closeAll()
          this.$message({
            type: 'success',
            message: '暂无报警信息。'
          })
        }
        if (res.data.cnt > 10) {
          this.download1(res.data.cnt)
        } else if (res.data.cnt > 0 && res.data.cnt <= 10) {
          this.download2(res.data.calllist)
        }
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download1 (cnt) {
      let params = {
        page: 1,
        size: cnt
      }
      let data = {
        from: this.callDate[0] + '000000',
        to: this.callDate[1] + '235959'
      }
      querycalllist(params, data).then(res => {
        this.download2(res.data.calllist)
      }).catch(() => {
        this.$message.closeAll()
      })
    },
    download2 (arr1) {
      let arr = []
      for (let i = 0; i < arr1.length; i++) {
        let obj = arr1[i]
        obj.begintime = arr1[i].begintime !== '0000-00-00 00:00:00' ? arr1[i].begintime : ''
        obj.dhfx = this.getCallType(arr1[i].calltype) // 电话方向
        obj.txbj = this.getCallTypeTag(arr1[i].typetag) // 通话标记
        obj.spendtime = this.getCallTime(arr1[i]) // 通话时长
        obj.isanswer = this.isCall(arr1[i]) // 是否接通
        arr.push(obj)
      }
      import('../../vendor/Export2Excel').then(excel => {
        const tHeader = ['用户姓名', '主叫号码', '被叫号码', '电话方向', '通话标记', '响铃时间', '接通时间', '结束时间', '通话时长', '是否接通', '通话小结', '客服号码', '客服姓名']
        const filterVal = ['p_name', 'fromnum', 'tonum', 'dhfx', 'txbj', 'calltime', 'begintime', 'endtime', 'spendtime', 'isanswer', 'remark', 'agentno', 'sp_name']
        const list = arr
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.callDate[0] + '-' + this.callDate[1] + '呼叫记录'
        })
      })
      setTimeout(() => {
        this.$message.closeAll()
      }, 1500)
    },
    formatJson (filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        return v[j]
      }))
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/statisticalform/callInfo.vue